import axios from 'axios'
import { routesDefaultRegister } from '../routes'
import { CANCEL,
    REQUEST_RECAPTCHA,
    REQUEST_RECAPTCHA_SUCCESS,
    REQUEST_RECAPTCHA_ERROR,
    REQUEST_APPLICATIONS,
    REQUEST_APPLICATIONS_SUCCESS,
    REQUEST_APPLICATIONS_ERROR,
    REQUEST_PHONE_CODES,
    REQUEST_PHONE_CODES_SUCCESS,
    REQUEST_PHONE_CODES_ERROR,
    SUBMIT_REQUEST,
    SUBMIT_REQUEST_SUCCESS,
    SUBMIT_REQUEST_ERROR,
    SESSION_TIMEOUT } from '../constants/default-register'
import { isSessionTimedOut } from '../utils/app-context'


export const sessionTimeout = () => ({ type: SESSION_TIMEOUT })

export const cancel = payload => ({ payload, type: CANCEL })

export const onSubmitRequest = () => ({ type: SUBMIT_REQUEST })
export const onSubmitRequestFailure = payload => ({ payload, type: SUBMIT_REQUEST_ERROR })
export const onSubmitRequestSuccess = payload => ({ payload, type: SUBMIT_REQUEST_SUCCESS })

export const onRequestReCaptcha = () => ({ type: REQUEST_RECAPTCHA })
export const onRequestReCaptchaFailure = payload => ({ payload, type: REQUEST_RECAPTCHA_ERROR })
export const onRequestReCaptchaSuccess = payload => ({ payload, type: REQUEST_RECAPTCHA_SUCCESS })

export const onSubmitAppRequest = () => ({ type: REQUEST_APPLICATIONS })
export const onSubmitAppRequestFailure = payload => ({ payload, type: REQUEST_APPLICATIONS_ERROR })
export const onSubmitAppRequestSuccess = payload => ({ payload, type: REQUEST_APPLICATIONS_SUCCESS })

export const onRequestPhoneCodes = () => ({ type: REQUEST_PHONE_CODES })
export const onRequestPhoneCodesFailure = payload => ({ payload, type: REQUEST_PHONE_CODES_ERROR })
export const onRequestPhoneCodesSuccess = payload => ({ payload, type: REQUEST_PHONE_CODES_SUCCESS })

let phoneCodesRequestInFlight = null


export const submitRequest = values => {
    return dispatch => {
        dispatch(onSubmitRequest())
        axios.post(routesDefaultRegister.submitRequest, values)
            .then(() => dispatch(onSubmitRequestSuccess()))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout)
                }
                dispatch(onSubmitRequestFailure(err.response.data.error))
            })
    }
}

export const requestRecaptcha = values => {
    return dispatch => {
        dispatch(onRequestReCaptcha())
        axios.get(routesDefaultRegister.requestRecaptcha)
            .then(result => dispatch(onRequestReCaptchaSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout)
                }
                dispatch(onRequestReCaptchaFailure(err.response.data.error))
            })
    }
}

export const requestApplication = () => {
    return dispatch => {
        dispatch(onSubmitAppRequest())
        axios.get(routesDefaultRegister.requestApplication)
            .then(result => dispatch(onSubmitAppRequestSuccess(result.data.data)))
            .catch(err => {
                if (isSessionTimedOut(err)) {
                    return dispatch(sessionTimeout())
                }
                dispatch(onSubmitAppRequestFailure(err.response.data.error))
            })
    }
}

export const requestPhoneCodes = () => {
    return (dispatch, getState) => {
        const state = getState?.()
        const existingPhoneCodes = state?.defaultRegister?.phoneCodes

        if (Array.isArray(existingPhoneCodes) && existingPhoneCodes.length > 0) {
            return Promise.resolve(existingPhoneCodes)
        }

        if (phoneCodesRequestInFlight) {
            return phoneCodesRequestInFlight
        }

        dispatch(onRequestPhoneCodes())

        phoneCodesRequestInFlight = axios.get(routesDefaultRegister.requestPhoneCodes)
            .then(result => {
                dispatch(onRequestPhoneCodesSuccess(result.data.data))
                return result.data.data
            })
            .catch(err => {
                dispatch(onRequestPhoneCodesFailure(err?.response?.data?.error))
                throw err
            })
            .finally(() => {
                phoneCodesRequestInFlight = null
            })

        return phoneCodesRequestInFlight
    }
}

